import { render, staticRenderFns } from "./ListaVidasAtivas.vue?vue&type=template&id=8871dfc2&scoped=true&"
import script from "./ListaVidasAtivas.vue?vue&type=script&lang=js&"
export * from "./ListaVidasAtivas.vue?vue&type=script&lang=js&"
import style0 from "./ListaVidasAtivas.vue?vue&type=style&index=0&id=8871dfc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8871dfc2",
  null
  
)

export default component.exports